import Header from './ReportHeaderPage';

export default Header;
